<template>
  <div class="delivery-on-going" v-if="order">
    <ul class="delivery-list">
      <li>
        <h6>{{ _T('Order Number') }}</h6>
        <h5>{{ order.order_no }}</h5>
      </li>
      <li>
        <h6>{{ _T('Date &amp; Time') }}</h6>
        <h5>{{ orderDate(order.real_created_datetime) }}</h5>
      </li>
    </ul>
    <div class="horizontal-timeline">
      <h6>{{ _T('Delivery') }}</h6>
      <ul>
        <li>
          <div class="media">
            <div class="timeline-icon">
              <svg width="16" height="16" fill="white">
                <use xlink:href="#store" />
              </svg>
            </div>
            <div class="media-body">
              <h6>{{ _T('Store address') }}</h6>
              <h5 v-if="storeAddress">
                <RestaurantAddress :address="storeAddress" />
              </h5>
              <h5 v-else>
                {{ _T('No address found') }}
              </h5>
            </div>
          </div>
        </li>
        <li>
          <div class="media">
            <div class="timeline-icon">
              <img src="/images/svg/food-details/user.svg" alt="" />
            </div>
            <div class="media-body">
              <h6>{{ _T('Delivery Address') }}</h6>
              <h5>
                {{ _T(deliveryAreaName(order.order_delivery_area)) }},
                {{
                  _T(order.order_building) +
                    ', ' +
                    _T(order.order_city) +
                    ', ' +
                    _T(order.order_country)
                }}
              </h5>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as utils from '@/utils/main_utils'
import RestaurantAddress from '@/components/Blocks/Util/RestaurantAddress'
export default {
  name: 'DeliveryOngoing',
  props: {
    order: {
      type: [Object, Array],
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters(['_T', 'deliveryAreaName', 'find_store_by_main_id']),
    storeAddress() {
      // return this.storeAddress(this.$route.params.store_id)
      return this.find_store_by_main_id(this.order.store_id)
    },
  },
  components: {
    RestaurantAddress,
  },
  methods: {
    orderDate(date) {
      if (date) {
        return utils.datetime_in_local_timezone(date)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.delivery-order {
  .media-delivery {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: $px15;
    .media-body {
      margin-left: $px16;
      h6 {
        font-size: $px12;
        line-height: $px15;
        margin-bottom: 0;
      }
      h3 {
        font-weight: bold;
        margin-bottom: 0;
      }
    }
    .badge {
      padding: $px10 $px30;
      border-radius: $px25;
      font-weight: 600;
      font-size: $px13;
      line-height: $px19;
      letter-spacing: 0.02em;
    }
    img {
      padding: $px4;
      border: $px2 solid $primary-color;
      border-radius: 100%;
      width: $px64;
      height: auto;
      @media (max-width: 575px) {
        min-width: $px85;
      }
    }
  }
}

.delivery-on-going {
  .delivery-list {
    border: $px1 solid $dark-border;
    border-radius: $px4;
    margin-bottom: $px20;

    li {
      display: block;
      padding: $px20;
      h6 {
        font-size: $px12;
        line-height: $px15;
        margin-bottom: $px6;
      }

      h5 {
        font-weight: 600;
        margin-bottom: 0;
        span {
          font-weight: 400;
        }
      }
    }
    li + li {
      border-top: $px1 solid $light-border;
    }
  }
  .horizontal-timeline {
    padding: $px10 0 0;
    border-top: $px1 dashed $light-border;
    h6 {
      font-weight: 600;
      font-size: $px14;
      line-height: $px22;
      letter-spacing: 0.005em;
      margin-bottom: $px4;
    }
    ul {
      display: block;
      position: relative;
      li {
        padding: $px10 $px20;
        border: $px1 solid $dark-border;
        border-radius: $px4;
        width: 100%;
        background-color: $white;

        &:first-child {
          .media {
            .timeline-icon {
              background-color: $warning-color;
              border: $px4 solid #fee9c3;
            }
          }
        }

        &:last-child {
          .media {
            .timeline-icon {
              background-color: $color-tertiary;
              border: $px4 solid $tertiary-light;
            }
          }
        }
        .media {
          align-items: center;
          display: flex;
          .timeline-icon {
            width: $px40;
            height: $px40;
            border-radius: 100%;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            img {
              width: $px16;
            }
          }
          .media-body {
            padding-left: $px18;
            h6 {
              font-weight: 600;
              line-height: $px22;
              letter-spacing: 0.005em;
              color: $light-font;
              margin-bottom: 0;
            }
            h5 {
              font-weight: 600;
              margin-bottom: 0;
            }
          }
        }
      }

      li + li {
        margin-left: 0;
        margin-top: $px35;
      }
    }
  }
}

li {
  display: inline-block;
}
h6 {
  font-size: $px14;
  font-weight: 400;
  line-height: $px24;
}

h5 {
  font-size: calc(#{$px15} + (16 - 15) * ((100vw - #{$px320}) / (1920 - 320)));
  font-weight: 400;
  line-height: $px19;
  letter-spacing: 0.02em;
}
img {
  vertical-align: middle;
  border-style: none;
}

.media {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.font-primary {
  color: $color-primary !important;
}

@media (min-width: 992px) {
  .col-lg-7 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 58.33333%;
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

.badge-delivered,
.delivered-title {
  background-color: $color-tertiary-1;
  color: $color-tertiary;
}
</style>
